export default __webpack_public_path__ + "static/media/non-gync-form-icon.b9a94a3a.svg";